<template>
  <div>
    <el-row class="tac">

      <el-col>

        <!--              等效参数计算-->
        <div style="padding-top: 20px " class="dengxiao" >
          <h2 style="text-align: center;padding-bottom: 20px">{{message}}</h2>

          <el-row :gutter="20" v-show="isshow">
            <el-col :span="6" v-for="item in coresList" >
              <div class="grid-content demo-image" style="text-align: center;">
                <div class="block"  >
                  <el-image style="width: 180px; height: 180px;" :src="item.img" src="" fit="fill" @click="dengxiaoJS(item.type)"/>
                  <p class="demonstration" > {{item.type}} </p>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20" v-show="!isshow" >
            <el-col :span="12"  style="border-right: 1px solid #ccc;padding-left: 50px">
              <el-form ref="form"  :model="form"
                       :rules="rules">
                <el-form-item label="A" prop="A" v-if="message!='计算氧分压'">
                  <el-input type="number" :min="0"  v-model="form.A" placeholder="请输入A尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="B" prop="B" v-if="message!='计算氧分压'">
                  <el-input type="number" :min="0"  v-model="form.B" placeholder="请输入B尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="B1" prop="B1" v-if="B1&&message!='计算氧分压'">
                  <el-input type="number" :min="0"  v-model="form.B1" placeholder="请输入B1尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="B2" prop="B2" v-if="message=='计算磁芯重量'&&types.includes('EFD')">
                  <el-input type="number" :min="0"  v-model="form.B2" placeholder="请输入B2尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="C" prop="C" v-if="message!='计算氧分压'">
                  <el-input type="number" :min="0"  v-model="form.C" placeholder="请输入C尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="D" prop="D" v-if="D&&message!='计算氧分压'" >
<!--               RM2没有D尺寸   -->
                  <el-input type="number" :min="0"  v-model="form.D" placeholder="请输入D尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="D1" prop="D1" v-if="D1&&message!='计算氧分压'">
<!--             EFD1 EFD2  EFD3  EPC1 EPC2-->
                  <el-input type="number" :min="0"  v-model="form.D1" placeholder="请输入D1尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="D2" prop="D2" v-if="message=='计算磁芯重量'&&types.includes('EFD2')">
                  <!--             EFD1 EFD2  EFD3  EPC1 EPC2-->
                  <el-input type="number" :min="0"  v-model="form.D2" placeholder="请输入D2尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="E" prop="E" v-if="E&&message!='计算氧分压'">
                  <el-input type="number" :min="0"  v-model="form.E" placeholder="请输入E尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="F" prop="F" v-if="F&&message!='计算氧分压'">
                  <el-input type="number" :min="0"  v-model="form.F" placeholder="请输入F尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="G" prop="G" v-if="G&&message!='计算氧分压'">
<!--             EI EIF EED UI PQ  EP -->
                  <el-input type="number" :min="0"  v-model="form.G" placeholder="请输入G尺寸" ></el-input>
                </el-form-item>
                  <el-form-item label="H" prop="H" v-if="H&&message!='计算氧分压'">
                    <!--             EFD1 EFD2 EFD3 EPC1 EPC2 PQ -->
                  <el-input type="number" :min="0"  v-model="form.H" placeholder="请输入H尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="H1" prop="H1" v-if="H1&&message!='计算氧分压'">
                  <!--             RM1 RM2 -->
                  <el-input type="number" :min="0"  v-model="form.H1" placeholder="请输入H1尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="I" prop="I" v-if="I&&message!='计算氧分压'">
                  <!--             RM1 RM2 PM -->
                  <el-input type="number" :min="0"  v-model="form.I" placeholder="请输入I尺寸" ></el-input>
                </el-form-item>
                <el-form-item label="Turns匝数N" prop="Turns" v-if="message=='计算磁芯的磁导率和AL'||message=='已知磁导率计算一定匝数时电感'||message=='计算磁芯的气隙和电感'">
                  <el-input type="number" :min="0"  v-model="form.turns" placeholder="请输入匝数" ></el-input>
                </el-form-item>
                <el-form-item label="Inductance电感L" prop="Inductance" v-if="message=='计算磁芯的磁导率和AL'||message=='已知磁导率计算一定电感时的匝数'">
                  <el-input type="number" :min="0"  v-model="form.inductance" placeholder="请输入Inductance电感L(mH)"/>
                </el-form-item>
                <el-form-item label="磁导率Ue" prop="Ue" v-if="message=='已知磁导率计算一定匝数时电感'||message=='已知磁导率计算一定电感时的匝数'||message=='计算磁芯的气隙和电感'">
                  <el-input type="number" :min="0"  v-model="form.ue" placeholder="请输入磁导率Ue" ></el-input>
                </el-form-item>
                <el-form-item label="Frequency频率f" prop="Frequency" v-if="message=='计算磁芯的输出功率'">
                  <el-input type="number" :min="0"  v-model="form.frequency" placeholder="请输入Frequency频率f(KHz)" ></el-input>
                </el-form-item>
                <el-form-item label="电流密度j" prop="j" v-if="message=='计算磁芯的输出功率'">
                  <el-input type="number" :min="0" :max="4" v-model="form.dianliumidu" placeholder="请输入电流密度j(A/mm2) 最大4" ></el-input>
                </el-form-item>
                <el-form-item label="窗口填充系数" prop="ckxs" v-if="message=='计算磁芯的输出功率'">
                  <el-input type="number" :min="0"  v-model="form.ckxs" placeholder="请输入窗口填充系数(KW) 常用0.4" ></el-input>
                </el-form-item>
                <el-form-item label="磁通密度T" prop="citongmidu" v-if="message=='计算磁芯的输出功率'">
                  <el-input type="number" :min="0"  v-model="form.citongmidu" placeholder="请输入磁通密度T(1T=1000mT)" ></el-input>
                </el-form-item>
                <el-form-item label="密度" prop="density" v-if="message=='计算磁芯的重量'">
                  <el-input type="number" :min="0"  v-model="form.density" placeholder="请输入密度(g/cm3)" ></el-input>
                </el-form-item>
                <el-form-item label="气隙深度" prop="gap" v-if="message=='计算磁芯的气隙和电感'">
                  <el-input type="number" :min="0"  v-model="form.gap" placeholder="请输入气隙深度(mm)" ></el-input>
                </el-form-item>
                <el-form-item label="重量" prop="weight" v-if="message=='计算磁芯的密度'">
                  <el-input type="number" :min="0"  v-model="form.weight" placeholder="请输入重量(g)" ></el-input>
                </el-form-item>

              </el-form>
            </el-col>
            <el-col :span="12" style="text-align: center">
              <el-image style="width: 50%;" :src="img" src="" fit="fill" />
            </el-col>
          </el-row>

          <el-button @click="submit" v-show="!isshow">计算</el-button>
          <el-button type="warning" v-show="!isshow" @click="isshow=true">返回</el-button>
        </div>
        <div v-show="!isshow">
          <el-table
              :data="resultData"
              border
              style="width: 100%">
            <el-table-column
                v-if="message!='计算氧分压'"
                prop="Le"
                label="Le">
            </el-table-column>
            <el-table-column
                v-if="message!='计算氧分压'"
                prop="Ae"
                label="Ae">
            </el-table-column>
            <el-table-column
                v-if="message!='计算氧分压'"
                prop="Ve"
                label="Ve">
            </el-table-column>
            <el-table-column
                prop="C1"
                label="C1">
            </el-table-column>
            <el-table-column
                prop="C2"
                label="C2">
            </el-table-column>
            <el-table-column
                v-if="message=='计算磁芯的磁导率和AL'"
                prop="Ue"
                label="磁导率Ue">
            </el-table-column>
            <el-table-column
                v-if="message=='计算磁芯的磁导率和AL'"
                prop="AL"
                label="AL">
            </el-table-column>
            <el-table-column
                v-if="message=='已知磁导率计算一定匝数时电感'"
                prop="inductance"
                label="Inductance电感L(mH)">
            </el-table-column>
            <el-table-column
                prop="turns"
                v-if="message=='已知磁导率计算一定电感时的匝数'"
                label="Turns匝数N">
            </el-table-column>
            <el-table-column
                v-if="message=='计算磁芯的输出功率'"
                prop="AW"
                label="AW">
            </el-table-column>
            <el-table-column
                v-if="message=='计算磁芯的输出功率'"
                prop="TPW"
                label="正激拓扑电路Po(w)">
            </el-table-column>
            <el-table-column
                v-if="message=='计算磁芯的输出功率'"
                prop="QQW"
                label="全桥推挽电路Po(w)">
            </el-table-column>
            <el-table-column
                v-if="message=='计算磁芯的重量'"
                prop="weight"
                label="重量g">
            </el-table-column>
            <el-table-column
                v-if="message=='计算磁芯的气隙和电感'"
              prop="dgysAL"
              label="电感因数AL">
            </el-table-column>
            <el-table-column
                v-if="message=='计算磁芯的气隙和电感'"
              prop="dgL"
              label="电感L(mH)">
            </el-table-column>
            <el-table-column
                v-if="message=='计算磁芯的密度'"
                prop="density"
                label="密度">
            </el-table-column>
          </el-table>
        </div>

      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  acalec,
  acalee,
  acaleed,
  acalefd,
  acalei,
  acalep,
  acalepc1,
  acalepc2,
  acalet,
  acalft,
  acalo,
  acalpm,
  acalpq, acalrma,
  acalrmb,
  acaluf,
  acalui,
  acaluyf,
  bcalec,
  bcalee,
  bcaleed,
  bcalefd2,
  bcalefd3,
  bcalefds,
  bcalei, bcalep,
  bcalepc1, bcalepc2,
  bcalet,
  bcalft,
  bcalo, bcalpm, bcalpq, bcalrma, bcalrmb,
  bcaluf,
  bcalui,
  bcaluyf
} from "@/assets/js/ca";
export default {
  name: "search",
  props: {
    message: {
      type: String,
      required: true
    },

  },
  data(){
    return{
      isshow:true,
      isPhone:"",
      form:{},
      img:require("@/assets/eechicun.png"),
      coresList:[
        {type:"EE",img:require("@/assets/EE.jpg")},
        {type:"UF",img:require("@/assets/UF.jpg")},
        {type:"环形",img:require("@/assets/h.jpg")},
        {type:"UYF",img:require("@/assets/uycores.png")},
        {type:"EC",img:require("@/assets/EC.jpg")},
        {type:"EI、EIF",img: require("@/assets/eicores.png")},
        {type:"EED",img:require("@/assets/eedcores.png")},
        {type:"UI",img: require("@/assets/uicores.png")},
        {type:"ET",img: require("@/assets/etcores.png")},
        {type:"FT",img: require("@/assets/ftcores.png")},
        {type:"EFD1",img: require("@/assets/efd1cores.png")},
        {type:"EFD2",img: require("@/assets/efd2cores.png")},
        {type:"EFD3",img: require("@/assets/efd3cores.png")},
        {type:"EPC1",img: require("@/assets/epc1cores.png")},
        {type:"EPC2",img: require("@/assets/epc2cores.png")},
        {type:"PQ",img: require("@/assets/PQ.jpg")},
        {type:"RM1",img: require("@/assets/rm1cores.png")},
        {type:"RM2",img: require("@/assets/rm2cores.png")},
        {type:"EP",img: require("@/assets/epcores.png")},
        {type:"PM",img: require("@/assets/pmcores.png")},


      ],
      D:true,
      D1:false,
      E:true,
      F:true,
      G:false,
      H:false,
      H1:false,
      I:false,
      B1:false,
      types:"EE",
      resultData:[],


      rules:{
        A:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
                callback();
              }


            },trigger: 'blur'}

        ],
        B:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
          },trigger: 'blur'}
        ],
       C:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        D:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        E:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        F:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
       G:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        H:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        B1:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        B2:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        D1:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        D2:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        I:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        Turns:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        Ue:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        Inductance:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        Frequency:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        j:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        ckxs:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        citongmidu:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        density:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        gap:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],
        weight:[
          { required: true, message: '此数据必须数据', trigger: 'blur' },
          {validator: function (rule, value, callback) {

              if (value) {
                let tip = "";
                if (value* 1<0){
                  tip = "此数据不能为负数"
                }

                if (tip) {
                  callback(new Error(tip));
                } else {
                  callback();
                }
              }else{
              }
            },trigger: 'blur'}
        ],






      }

    }
  }
  ,methods: {


    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    dengxiaoJS(types) {
      this.isshow = false
      this.types = types


      if (types == "EE") {
        this.img = require("@/assets/eechicun.png");
        this.setSizeStatus(true, false, true, true, false, false, false, false, false)

      } else if (types == "UF") {
        this.img = require("@/assets/ufchicun.png");
        this.setSizeStatus(true, false, true, true, false, false, false, false, false)
      } else if (types == "环形") {
        this.img = require("@/assets/hchicun.png");
        this.setSizeStatus(false, false, false, false, false, false, false, false, false)
      } else if (types == "UYF") {
        this.img = require("@/assets/uyfchicun.png");
        this.setSizeStatus(true, false, true, true, false, false, false, false, false)

      } else if (types == "EC") {
        this.img = require("@/assets/ecchicun.png");
        this.setSizeStatus(true, false, true, true, false, false, false, false, false)
      } else if (types == "EI、EIF") {
        this.img = require("@/assets/eichicun.png");
        this.setSizeStatus(true, false, true, true, true, false, false, false, false)
      } else if (types == "EED") {
        this.img = require("@/assets/eedchicun.png");
        this.setSizeStatus(true, false, true, true, true, false, false, false, false)
      } else if (types == "UI") {
        this.img = require("@/assets/uichicun.png");
        this.setSizeStatus(true, false, true, true, true, false, false, false, false)
      } else if (types == "ET") {
        this.img = require("@/assets/etchicun.png");
        this.setSizeStatus(true, false, true, true, false, false, false, false, false)
      } else if (types == "FT") {
        this.img = require("@/assets/ftchicun.png");
        this.setSizeStatus(true, false, true, true, false, false, false, false, false)
      } else if (types == "EFD1") {
        this.img = require("@/assets/efd1chicun.png");
        this.setSizeStatus(true, true, true, true, false, true, false, false, false)
      } else if (types == "EFD2") {
        this.img = require("@/assets/efd2chicun.png");
        this.setSizeStatus(true, true, true, true, false, true, false, false, false)
      } else if (types == "EFD3") {
        this.img = require("@/assets/efd3chicun.png");
        this.setSizeStatus(true, true, true, true, false, true, false, false, false)
      } else if (types == "EPC1") {
        this.img = require("@/assets/epc1chicun.png");
        this.setSizeStatus(true, true, true, true, false, true, false, false, false)

      } else if (types == "EPC2") {
        this.img = require("@/assets/epc2chicun.png");
        this.setSizeStatus(true, true, true, true, false, true, false, false, false)

      } else if (types == "PQ") {
        this.img = require("@/assets/pqchicun.png");
        this.setSizeStatus(true, false, true, true, true, true, false, false, false)
      } else if (types == "RM1") {
        this.img = require("@/assets/rm1chicun.png");
        this.setSizeStatus(true, false, true, true, true, true, true, true, false)

      } else if (types == "RM2") {
        this.img = require("@/assets/rm2chicun.png");
        this.setSizeStatus(true, false, true, true, false, true, false, false, true)

      } else if (types == "EP") {
        this.img = require("@/assets/epchicun.png");
        this.setSizeStatus(true, false, true, true, true, false, false, false, false)

      } else if (types == "PM") {
        this.img = require("@/assets/pmchicun.png");
        this.setSizeStatus(true, false, true, true, true, true, false, true, false)
      }
    },
    changeIsShow() {
      this.isshow = true;
    },

    setSizeStatus(d, d1, e, f, g, h, h1, i, b1) {
      this.D = d
      this.D1 = d1
      this.E = e
      this.F = f
      this.G = g
      this.H = h
      this.H1 = h1
      this.I = i
      this.B1 = b1

    }
    , submit() {
      this.resultData = []
      this.$refs['form'].validate((valid) => {
        if (valid){
      if (this.message == "计算磁芯等效参数") {
        if (this.types == "EE") {
          this.resultData.push(acalee(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F));
        } else if (this.types == "UF") {
          this.resultData.push(acaluf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F));
        } else if (this.types == "环形") {
          this.resultData.push(acalo(this.form.A, this.form.B, this.form.C));
        } else if (this.types == "UYF") {
          this.resultData.push(acaluyf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F));
        } else if (this.types == "EC") {
          this.resultData.push(acalec(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F));
        } else if (this.types == "EI、EIF") {
          this.resultData.push(acalei(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G));
        } else if (this.types == "EED") {
          this.resultData.push(acaleed(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G));
        } else if (this.types == "UI") {
          this.resultData.push(acalui(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G));
        } else if (this.types == "ET") {
          this.resultData.push(acalet(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F));
        } else if (this.types == "FT") {
          this.resultData.push(acalft(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F));
        } else if (this.types == "EFD1") {
          this.resultData.push(acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H));
        } else if (this.types == "EFD2") {
          this.resultData.push(acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H));
        } else if (this.types == "EFD3") {
          this.resultData.push(acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H));
        } else if (this.types == "EPC1") {
          this.resultData.push(acalepc1(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H));
        } else if (this.types == "EPC2") {
          this.resultData.push(acalepc2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H));
        } else if (this.types == "PQ") {
          this.resultData.push(acalpq(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H));
        } else if (this.types == "RM1") {
          this.resultData.push(acalrma(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I));
        } else if (this.types == "RM2") {
          this.resultData.push(acalrmb(this.form.A, this.form.B, this.form.C, 0, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I));
        } else if (this.types == "EP") {
          this.resultData.push(acalep(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G));
        } else if (this.types == "PM") {
          this.resultData.push(acalpm(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.I));
        }
      } else if (this.message == "计算磁芯的磁导率和AL") {
        if (this.types == "EE") {
          var acalee1 = acalee(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalee1.Le / acalee1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalee1.Ue = ue.toFixed(0);
          acalee1.AL = al.toFixed(0);
          this.resultData.push(acalee1);
        } else if (this.types == "UF") {
          var acaluf1 = acaluf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acaluf1.Le / acaluf1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acaluf1.Ue = ue.toFixed(0);
          acaluf1.AL = al.toFixed(0);
          this.resultData.push(acaluf1);
        } else if (this.types == "环形") {
          var acalo1 = acalo(this.form.A, this.form.B, this.form.C);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalo1.Le / acalo1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalo1.Ue = ue.toFixed(0);
          acalo1.AL = al.toFixed(0);
          this.resultData.push(acalo1);
        } else if (this.types == "UYF") {
          var acaluyf1 = acaluyf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acaluyf1.Le / acaluyf1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acaluyf1.Ue = ue.toFixed(0);
          acaluyf1.AL = al.toFixed(0);
          this.resultData.push(acaluf1);
        } else if (this.types == "EC") {
          var acalec1 = acalec(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalec1.Le / acalec1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalec1.Ue = ue.toFixed(0);
          acalec1.AL = al.toFixed(0);
          this.resultData.push(acalec1);
        } else if (this.types == "EI、EIF") {

          var acalefd1 = acalei(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalefd1.Le / acalefd1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalefd1.Ue = ue.toFixed(0);
          acalefd1.AL = al.toFixed(0);
          this.resultData.push(acalefd1);
        } else if (this.types == "EED") {
          var acaleed1 = acaleed(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acaleed1.Le / acaleed1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acaleed1.Ue = ue.toFixed(0);
          acaleed1.AL = al.toFixed(0);
          this.resultData.push(acaleed1);
        } else if (this.types == "UI") {
          var acalui1 = acalui(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalui1.Le / acalui1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalui1.Ue = ue.toFixed(0);
          acalui1.AL = al.toFixed(0);
          this.resultData.push(acalui1);
        } else if (this.types == "ET") {
          var acalet1 = acalet(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalet1.Le / acalet1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalet1.Ue = ue.toFixed(0);
          acalet1.AL = al.toFixed(0);
          this.resultData.push(acalet1);
        } else if (this.types == "FT") {

          var acalft1 = acalft(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalft1.Le / acalft1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns)
          acalft1.Ue = ue.toFixed(0);
          acalft1.AL = al.toFixed(0);
          this.resultData.push(acalft1);
        } else if (this.types == "EFD1" || this.types == "EFD2" || this.types == "EFD3") {

          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalefd1.Le / acalefd1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalefd1.Ue = ue.toFixed(0);
          acalefd1.AL = al.toFixed(0);
          this.resultData.push(acalefd1);
        } else if (this.types == "EPC1") {
          var acalepc = acalepc1(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalepc.Le / acalepc.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalepc.Ue = ue.toFixed(0);
          acalepc.AL = al.toFixed(0);
          this.resultData.push(acalepc);
        } else if (this.types == "EPC2") {

          var acalepc = acalepc2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalepc.Le / acalepc.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalepc.Ue = ue.toFixed(0);
          acalepc.AL = al.toFixed(0);
          this.resultData.push(acalepc);
        } else if (this.types == "PQ") {

          var acalpq1 = acalpq(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalpq1.Le / acalpq1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalpq1.Ue = ue.toFixed(0);
          acalpq1.AL = al.toFixed(0);

          this.resultData.push(acalpq1);
        } else if (this.types == "RM1") {
          var acalrmb1 = acalrma(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalrmb1.Le / acalrmb1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalrmb1.Ue = ue.toFixed(0);
          acalrmb1.AL = al.toFixed(0);

          this.resultData.push(acalrmb1);
        } else if (this.types == "RM2") {
          var acalrmb1 = acalrmb(this.form.A, this.form.B, this.form.C, 0, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalrmb1.Le / acalrmb1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalrmb1.Ue = ue.toFixed(0);
          acalrmb1.AL = al.toFixed(0);

          this.resultData.push(acalrmb1);
        } else if (this.types == "EP") {
          var acalep1 = acalep(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalep1.Le / acalep1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalep1.Ue = ue.toFixed(0);
          acalep1.AL = al.toFixed(0);
          this.resultData.push(acalep1);
        } else if (this.types == "PM") {
          var acalpm1 = acalpm(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.I);
          var ue = this.form.inductance / 1000 / (0.000001256637 * (this.form.turns * this.form.turns)) * acalpm1.Le / acalpm1.Ae * 1000;
          var al = (this.form.inductance * 1000000) / (this.form.turns * this.form.turns);
          acalpm1.Ue = ue.toFixed(0);
          acalpm1.AL = al.toFixed(0);
          this.resultData.push(acalpm1);
        }


      } else if (this.message == '已知磁导率计算一定匝数时电感') {
        if (this.types == "EE") {
          var acalee1 = acalee(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalee1.Ae / acalee1.Le
          acalee1.inductance = mh.toFixed(6);
          this.resultData.push(acalee1);
        } else if (this.types == "UF") {
          var acaluf1 = acaluf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acaluf1.Ae / acaluf1.Le
          acaluf1.inductance = mh.toFixed(6);
          this.resultData.push(acaluf1);
        } else if (this.types == "环形") {
          var acalo1 = acalo(this.form.A, this.form.B, this.form.C);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalo1.Ae / acalo1.Le
          acalo1.inductance = mh.toFixed(6);
          this.resultData.push(acalo1);
        } else if (this.types == "UYF") {
          var acaluyf1 = acaluyf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acaluyf1.Ae / acaluyf1.Le
          acaluyf1.inductance = mh.toFixed(6);
          this.resultData.push(acaluf1);
        } else if (this.types == "EC") {
          var acalec1 = acalec(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalec1.Ae / acalec1.Le
          acalec1.inductance = mh.toFixed(6);

          this.resultData.push(acalec1);
        } else if (this.types == "EI、EIF") {

          var acalefd1 = acalei(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalefd1.Ae / acalefd1.Le
          acalefd1.inductance = mh.toFixed(6);
          this.resultData.push(acalefd1);
        } else if (this.types == "EED") {
          var acaleed1 = acaleed(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acaleed1.Ae / acaleed1.Le
          acaleed1.inductance = mh.toFixed(6);
          this.resultData.push(acaleed1);
        } else if (this.types == "UI") {
          var acalui1 = acalui(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalui1.Ae / acalui1.Le
          acalui1.inductance = mh.toFixed(6);
          this.resultData.push(acalui1);
        } else if (this.types == "ET") {
          var acalet1 = acalet(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalet1.Ae / acalet1.Le
          acalet1.inductance = mh.toFixed(6);
          this.resultData.push(acalet1);
        } else if (this.types == "FT") {

          var acalft1 = acalft(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalft1.Ae / acalft1.Le
          acalft1.inductance = mh.toFixed(6);
          this.resultData.push(acalft1);
        } else if (this.types == "EFD1" || this.types == "EFD2" || this.types == "EFD3") {

          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalefd1.Ae / acalefd1.Le
          acalefd1.inductance = mh.toFixed(6);
          this.resultData.push(acalefd1);
        } else if (this.types == "EPC1") {
          var acalepc = acalepc1(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalepc.Ae / acalepc.Le
          acalepc.inductance = mh.toFixed(6);
          this.resultData.push(acalepc);
        } else if (this.types == "EPC2") {

          var acalepc = acalepc2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalepc.Ae / acalepc.Le
          acalepc.inductance = mh.toFixed(6);
          this.resultData.push(acalepc);
        } else if (this.types == "PQ") {

          var acalpq1 = acalpq(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalpq1.Ae / acalpq1.Le
          acalpq1.inductance = mh.toFixed(6);

          this.resultData.push(acalpq1);
        } else if (this.types == "RM1") {
          var acalrmb1 = acalrma(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalrmb1.Ae / acalrmb1.Le
          acalrmb1.inductance = mh.toFixed(6);

          this.resultData.push(acalrmb1);
        } else if (this.types == "RM2") {
          var acalrmb1 = acalrmb(this.form.A, this.form.B, this.form.C, 0, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalrmb1.Ae / acalrmb1.Le
          acalrmb1.inductance = mh.toFixed(6);

          this.resultData.push(acalrmb1);
        } else if (this.types == "EP") {
          var acalep1 = acalep(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalep1.Ae / acalep1.Le
          acalep1.inductance = mh.toFixed(6);
          this.resultData.push(acalep1);
        } else if (this.types == "PM") {
          var acalpm1 = acalpm(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.I);
          var mh = this.form.ue * 0.000001256637 * (this.form.turns * this.form.turns) * acalpm1.Ae / acalpm1.Le
          acalpm1.inductance = mh.toFixed(6);
          this.resultData.push(acalpm1);
        }
      } else if (this.message == "已知磁导率计算一定电感时的匝数") {
        if (this.types == "EE") {
          var acalee1 = acalee(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalee1.Le / 1000) / (acalee1.Ae / 1000000));
          acalee1.turns = number.toFixed(1);
          this.resultData.push(acalee1);
        } else if (this.types == "UF") {
          var acaluf1 = acaluf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acaluf1.Le / 1000) / (acaluf1.Ae / 1000000));
          acaluf1.turns = number.toFixed(1);
          this.resultData.push(acaluf1);
        } else if (this.types == "环形") {
          var acalo1 = acalo(this.form.A, this.form.B, this.form.C);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalo1.Le / 1000) / (acalo1.Ae / 1000000));
          acalo1.turns = number.toFixed(1);
          this.resultData.push(acalo1);
        } else if (this.types == "UYF") {
          var acaluyf1 = acaluyf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acaluyf1.Le / 1000) / (acaluyf1.Ae / 1000000));
          acaluyf1.turns = number.toFixed(1);
          this.resultData.push(acaluyf1);
        } else if (this.types == "EC") {
          var acalec1 = acalec(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalec1.Le / 1000) / (acalec1.Ae / 1000000));
          acalec1.turns = number.toFixed(1);
          this.resultData.push(acalec1);
        } else if (this.types == "EI、EIF") {
          var acalei1 = acalei(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalei1.Le / 1000) / (acalei1.Ae / 1000000));
          acalei1.turns = number.toFixed(1);
          this.resultData.push(acalei1);
        } else if (this.types == "EED") {
          var acaleed1 = acaleed(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acaleed1.Le / 1000) / (acaleed1.Ae / 1000000));
          acaleed1.turns = number.toFixed(1);
          this.resultData.push(acaleed1);
        } else if (this.types == "UI") {
          var acalui1 = acalui(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalui1.Le / 1000) / (acalui1.Ae / 1000000));
          acalui1.turns = number.toFixed(1);
          this.resultData.push(acalui1);
        } else if (this.types == "ET") {
          var acalet1 = acalet(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalet1.Le / 1000) / (acalet1.Ae / 1000000));
          acalet1.turns = number.toFixed(1);
          this.resultData.push(acalet1);
        } else if (this.types == "FT") {
          var acalft1 = acalft(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalft1.Le / 1000) / (acalft1.Ae / 1000000));
          acalft1.turns = number.toFixed(1);
          this.resultData.push(acalft1);
        } else if (this.types == "EFD1" || this.types == "EFD2" || this.types == "EFD3") {
          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalefd1.Le / 1000) / (acalefd1.Ae / 1000000));
          acalefd1.turns = number.toFixed(1);
          this.resultData.push(acalefd1);

        } else if (this.types == "EPC1") {
          var acalepc = acalepc1(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalepc.Le / 1000) / (acalepc.Ae / 1000000));
          acalepc.turns = number.toFixed(1);
          this.resultData.push(acalepc);
        } else if (this.types == "EPC2") {
          var acalepc = acalepc2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalepc.Le / 1000) / (acalepc.Ae / 1000000));
          acalepc.turns = number.toFixed(1);
          this.resultData.push(acalepc);
        } else if (this.types == "PQ") {
          var acalpq1 = acalpq(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalpq1.Le / 1000) / (acalpq1.Ae / 1000000));
          acalpq1.turns = number.toFixed(1);
          this.resultData.push(acalpq1);
        } else if (this.types == "RM1") {
          var acalrmb1 = acalrma(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalrmb1.Le / 1000) / (acalrmb1.Ae / 1000000));
          acalrmb1.turns = number.toFixed(1);
          this.resultData.push(acalrmb1);
        } else if (this.types == "RM2") {
          var acalrmb1 = acalrmb(this.form.A, this.form.B, this.form.C, 0, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalrmb1.Le / 1000) / (acalrmb1.Ae / 1000000));
          acalrmb1.turns = number.toFixed(1);
          this.resultData.push(acalrmb1);
        } else if (this.types == "EP") {
          var acalep1 = acalep(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalep1.Le / 1000) / (acalep1.Ae / 1000000));
          acalep1.turns = number.toFixed(1);
          this.resultData.push(acalep1);
        } else if (this.types == "PM") {
          var acalpm1 = acalpm(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.I);
          var number = Math.sqrt(this.form.inductance / 1000 / (0.000001256637 * this.form.ue) * (acalpm1.Le / 1000) / (acalpm1.Ae / 1000000));
          acalpm1.turns = number.toFixed(1);
          this.resultData.push(acalpm1);
        }

      } else if (this.message == "计算磁芯的输出功率") {
        if (this.types == "EE") {
          var acalee1 = acalee(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalee1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalee1.Ae * aw;
          acalee1.AW = aw.toFixed(3)
          acalee1.TPW = po1.toFixed(1)
          acalee1.QQW = po2.toFixed(1)
          this.resultData.push(acalee1);

        } else if (this.types == "UF") {
          var acaluf1 = acaluf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acaluf1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acaluf1.Ae * aw;
          acaluf1.AW = aw.toFixed(3)
          acaluf1.TPW = po1.toFixed(1)
          acaluf1.QQW = po2.toFixed(1)
          this.resultData.push(acaluf1);
        } else if (this.types == "环形") {
          var acalo1 = acalo(this.form.A, this.form.B, this.form.C);
          var aw = this.form.B / 2 * this.form.B / 2 * 3.14
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalo1.Ae * aw;
          var po1 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalo1.Ae * aw;
          acalo1.AW = aw.toFixed(3)
          acalo1.TPW = po1.toFixed(1)
          acalo1.QQW = po2.toFixed(1)
          this.resultData.push(acalo1);

        } else if (this.types == "UYF") {
          var acaluyf1 = acaluyf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var aw = this.form.B * this.form.E * 2;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acaluyf1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acaluyf1.Ae * aw;
          acaluyf1.AW = aw.toFixed(3)
          acaluyf1.TPW = po1.toFixed(1)
          acaluyf1.QQW = po2.toFixed(1)
          this.resultData.push(acaluyf1);
        } else if (this.types == "EC") {
          var acalec1 = acalec(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalec1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalec1.Ae * aw;
          acalec1.AW = aw.toFixed(3)
          acalec1.TPW = po1.toFixed(1)
          acalec1.QQW = po2.toFixed(1)
          this.resultData.push(acalec1);

        } else if (this.types == "EI、EIF") {

          var acalefd1 = acalei(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalefd1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalefd1.Ae * aw;
          acalefd1.AW = aw.toFixed(3)
          acalefd1.TPW = po1.toFixed(1)
          acalefd1.QQW = po2.toFixed(1)
          this.resultData.push(acalefd1);

        } else if (this.types == "EED") {
          var acaleed1 = acaleed(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acaleed1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acaleed1.Ae * aw;
          acaleed1.AW = aw.toFixed(3)
          acaleed1.TPW = po1.toFixed(1)
          acaleed1.QQW = po2.toFixed(1)
          this.resultData.push(acaleed1);
        } else if (this.types == "UI") {
          var acalui1 = acalui(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var aw = this.form.B * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalui1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalui1.Ae * aw;
          acalui1.AW = aw.toFixed(3)
          acalui1.TPW = po1.toFixed(1)
          acalui1.QQW = po2.toFixed(1)
          this.resultData.push(acalui1);
        } else if (this.types == "ET") {
          var acalet1 = acalet(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var aw = (this.form.B - this.form.C) * this.form.B * 0.5;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalet1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalet1.Ae * aw;
          acalet1.AW = aw.toFixed(3)
          acalet1.TPW = po1.toFixed(1)
          acalet1.QQW = po2.toFixed(1)
          this.resultData.push(acalet1);
        } else if (this.types == "FT") {

          var acalft1 = acalft(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var aw = this.form.B * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalft1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalft1.Ae * aw;
          acalft1.AW = aw.toFixed(3)
          acalft1.TPW = po1.toFixed(1)
          acalft1.QQW = po2.toFixed(1)
          this.resultData.push(acalft1)
        } else if (this.types == "EFD1" || this.types == "EFD2" || this.types == "EFD3") {

          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalefd1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalefd1.Ae * aw;
          acalefd1.AW = aw.toFixed(3)
          acalefd1.TPW = po1.toFixed(1)
          acalefd1.QQW = po2.toFixed(1)
          this.resultData.push(acalefd1);
        } else if (this.types == "EPC1") {
          var acalepc = acalepc1(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalepc.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalepc.Ae * aw;
          acalepc.AW = aw.toFixed(3)
          acalepc.TPW = po1.toFixed(1)
          acalepc.QQW = po2.toFixed(1)
          this.resultData.push(acalepc);
        } else if (this.types == "EPC2") {

          var acalepc = acalepc2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalepc.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalepc.Ae * aw;
          acalepc.AW = aw.toFixed(3)
          acalepc.TPW = po1.toFixed(1)
          acalepc.QQW = po2.toFixed(1)
          this.resultData.push(acalepc);
        } else if (this.types == "PQ") {
          var acalpq1 = acalpq(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalpq1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalpq1.A
          acalpq1.AW = aw.toFixed(3)
          acalpq1.TPW = po1.toFixed(1)
          acalpq1.QQW = po2.toFixed(1)
          this.resultData.push(acalpq1);
        } else if (this.types == "RM1") {
          var acalrmb1 = acalrma(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalrmb1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalrmb1.Ae * aw;
          acalrmb1.AW = aw.toFixed(3)
          acalrmb1.TPW = po1.toFixed(1)
          acalrmb1.QQW = po2.toFixed(1)
          this.resultData.push(acalrmb1);
        } else if (this.types == "RM2") {
          var acalrmb1 = acalrmb(this.form.A, this.form.B, this.form.C, 0, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalrmb1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalrmb1.Ae * aw;
          acalrmb1.AW = aw.toFixed(3)
          acalrmb1.TPW = po1.toFixed(1)
          acalrmb1.QQW = po2.toFixed(1)
          this.resultData.push(acalrmb1);
        } else if (this.types == "EP") {
          var acalep1 = acalep(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalep1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalep1.Ae * aw;
          acalep1.AW = aw.toFixed(3)
          acalep1.TPW = po1.toFixed(1)
          acalep1.QQW = po2.toFixed(1)
          this.resultData.push(acalep1);
        } else if (this.types == "PM") {
          var acalpm1 = acalpm(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.I);
          var aw = (this.form.B - this.form.C) * this.form.E;
          var po1 = 0.0006325 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalpm1.Ae * aw;
          var po2 = 0.00179 * this.form.frequency * this.form.citongmidu * this.form.dianliumidu * this.form.ckxs * acalpm1.Ae * aw;
          acalpm1.AW = aw.toFixed(3)
          acalpm1.TPW = po1.toFixed(1)
          acalpm1.QQW = po2.toFixed(1)
          this.resultData.push(acalpm1);
        }
      } else if (this.message == "计算磁芯的重量") {
        if (this.types == "EE") {
          var acalee1 = acalee(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcalee1 = bcalee(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = bcalee1 * this.form.density / 1000;
          acalee1.weight = zzl.toFixed(3)
          this.resultData.push(acalee1)
        } else if (this.types == "UF") {
          var acaluf1 = acaluf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcaluf1 = bcaluf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = bcaluf1 * this.form.density / 1000;
          acaluf1.weight = zzl.toFixed(3)
          this.resultData.push(acaluf1);
        } else if (this.types == "环形") {
          var acalo1 = acalo(this.form.A, this.form.B, this.form.C);
          var bcalo1 = bcalo(this.form.A, this.form.B, this.form.C)
          var zzl = bcalo1 * this.form.density / 1000;
          acalo1.weight = zzl.toFixed(3)

          this.resultData.push(acalo1);

        } else if (this.types == "UYF") {
          var acaluyf1 = acaluyf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcaluyf1 = bcaluyf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = bcaluyf1 * this.form.density / 1000;
          acaluyf1.weight = zzl.toFixed(3)
          this.resultData.push(acaluyf1);
        } else if (this.types == "EC") {
          var acalec1 = acalec(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcalec1 = bcalec(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = bcalec1 * this.form.density / 1000;
          acalec1.weight = zzl.toFixed(3)

          this.resultData.push(acalec1);

        } else if (this.types == "EI、EIF") {

          var acalefd1 = acalei(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalefd1 = bcalei(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H)
          var zzl = bcalefd1 * this.form.density / 1000;
          acalefd1.weight = zzl.toFixed(3)
          this.resultData.push(acalefd1);

        } else if (this.types == "EED") {
          var acaleed1 = acaleed(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var bcaleed1 = bcaleed(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G)
          var zzl = bcaleed1 * this.form.density / 1000;
          acaleed1.weight = zzl.toFixed(3)
          this.resultData.push(acaleed1);
        } else if (this.types == "UI") {
          var acalui1 = acalui(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var bcalui1 = bcalui(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G)
          var zzl = bcalui1 * this.form.density / 1000;
          acalui1.weight = zzl.toFixed(3)
          this.resultData.push(acalui1);
        } else if (this.types == "ET") {
          var acalet1 = acalet(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcalet1 = bcalet(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = bcalet1 * this.form.density / 1000;
          acalet1.weight = zzl.toFixed(3)
          this.resultData.push(acalet1);
        } else if (this.types == "FT") {

          var acalft1 = acalft(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcalft1 = bcalft(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = bcalft1 * this.form.density / 1000;
          acalft1.weight = zzl.toFixed(3)
          this.resultData.push(acalft1)
        } else if (this.types == "EFD1") {

          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalefd = bcalefds(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H, this.from.B2);
          var zzl = bcalefd * this.form.density / 1000;
          acalefd1.weight = zzl.toFixed(3)
          acalefd1.QQW = po2.toFixed(1)
          this.resultData.push(acalefd1);
        } else if (this.types == "EFD2") {
          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalefd = bcalefd2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H, this.from.B2, this.form.D2);
          var zzl = bcalefd * this.form.density / 1000;
          acalefd1.weight = zzl.toFixed(3)
          acalefd1.QQW = po2.toFixed(1)
          this.resultData.push(acalefd1);
        } else if (this.types == "EFD3") {
          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalefd = bcalefd3(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H, this.from.B2, this.form.D2);
          var zzl = bcalefd * this.form.density / 1000;
          acalefd1.weight = zzl.toFixed(3)
          acalefd1.QQW = po2.toFixed(1)
        } else if (this.types == "EPC1") {
          var acalepc = acalepc1(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalepc = bcalepc1(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H)
          var zzl = bcalepc * this.form.density / 1000;
          acalepc.weight = zzl.toFixed(3)
          this.resultData.push(acalepc);
        } else if (this.types == "EPC2") {

          var acalepc = acalepc2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalepc = bcalepc2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H)
          var zzl = bcalepc * this.form.density / 1000;
          acalepc.weight = zzl.toFixed(3)
          this.resultData.push(acalepc);
        } else if (this.types == "PQ") {
          var acalpq1 = acalpq(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H);
          var po2 = bcalpq(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H)
          var zzl = po2 * this.form.density / 1000;
          acalpq1.weight = zzl.toFixed(3)
          this.resultData.push(acalpq1);
        } else if (this.types == "RM1") {
          var acalrmb1 = acalrma(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var po2 = bcalrma(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I)
          var zzl = po2 * this.form.density / 1000;
          acalrmb1.weight = zzl.toFixed(3)
          this.resultData.push(acalrmb1);
        } else if (this.types == "RM2") {
          var acalrmb1 = acalrmb(this.form.A, this.form.B, this.form.C, 0, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var po2 = bcalrmb(this.form.A, this.form.B, this.form.C, 0, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I)
          var zzl = po2 * this.form.density / 1000;
          acalrmb1.weight = zzl.toFixed(3)
          this.resultData.push(acalrmb1);
        } else if (this.types == "EP") {
          var acalep1 = acalep(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var po2 = bcalep(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G)
          var zzl = po2 * this.form.density / 1000;
          acalep1.weight = zzl.toFixed(3)
          this.resultData.push(acalep1);
        } else if (this.types == "PM") {
          var acalpm1 = acalpm(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.I);
          var po2 = bcalpm(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.I)
          var zzl = po2 * this.form.density / 1000;
          acalpm1.weight = zzl.toFixed(3)
          this.resultData.push(acalpm1);
        }
      } else if (this.message == "计算磁芯的气隙和电感") {
        if (this.types == "EE") {
          var acalee1 = acalee(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acalee1.Le + (UE - 1) * GAP);

          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalee1.dgL = lmh.toFixed(8)
          acalee1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalee1)
        } else if (this.types == "UF") {
          var acaluf1 = acaluf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acaluf1.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acaluf1.dgL = lmh.toFixed(8)
          acaluf1.dgysAL = aal.toFixed(0)
          this.resultData.push(acaluf1);
        } else if (this.types == "环形") {
          var acalo1 = acalo(this.form.A, this.form.B, this.form.C);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat((this.form.A - this.form.B) / 2);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acalo1.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalo1.dgL = lmh.toFixed(8)
          acalo1.dgysAL = aal.toFixed(0)

          this.resultData.push(acalo1);

        } else if (this.types == "UYF") {
          var acaluyf1 = acaluyf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var suo = 0.0000012566;
          var fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);

          fj1 = GAP / C;
          if (fj1 <= 0.05) {
            lmh = 0.7853 * TURNS * TURNS * suo * UE * (C + GAP)
                * (C + GAP) / (acaluyf1.Le + (UE - 1) * GAP);
          } else {
            lmh = 0.7853 * TURNS * TURNS * suo
                * (C + GAP) * (C + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acaluyf1.dgL = lmh.toFixed(8)
          acaluyf1.dgysAL = aal.toFixed(0)
          this.resultData.push(acaluyf1);
        } else if (this.types == "EC") {
          var acalec1 = acalec(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var suo = 0.0000012566;
          var fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);

          fj1 = GAP / C;
          if (fj1 <= 0.05) {
            lmh = 0.7853 * TURNS * TURNS * suo * UE * (C + GAP)
                * (C + GAP) / (acalec1.Le + (UE - 1) * GAP);
          } else {
            lmh = 0.7853 * TURNS * TURNS * suo
                * (C + GAP) * (C + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalec1.dgL = lmh.toFixed(8)
          acalec1.dgysAL = aal.toFixed(0)

          this.resultData.push(acalec1);

        } else if (this.types == "EI、EIF") {

          var acalei1 = acalei(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acalei1.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalei1.dgL = lmh.toFixed(8)
          acalei1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalei1);

        } else if (this.types == "EED") {
          var acaleed1 = acaleed(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acaleed1.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acaleed1.dgL = lmh.toFixed(8)
          acaleed1.dgysAL = aal.toFixed(0)
          this.resultData.push(acaleed1);
        } else if (this.types == "UI") {
          var acalui1 = acalui(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acalui1.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalui1.dgL = lmh.toFixed(8)
          acalui1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalui1);
        } else if (this.types == "ET") {
          var acalet1 = acalet(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acalet1.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalet1.dgL = lmh.toFixed(8)
          acalet1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalet1);
        } else if (this.types == "FT") {

          var acalft1 = acalft(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acalft1.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalft1.dgL = lmh.toFixed(8)
          acalft1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalft1)
        } else if (this.types == "EFD1") {

          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acalefd1.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalefd1.dgL = lmh.toFixed(8)
          acalefd1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalefd1);
        } else if (this.types == "EFD2") {
          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acalefd1.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalefd1.dgL = lmh.toFixed(8)
          acalefd1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalefd1);
        } else if (this.types == "EFD3") {
          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acalefd1.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalefd1.dgL = lmh.toFixed(8)
          acalefd1.dgysAL = aal.toFixed(0)
          acalefd1.QQW = po2.toFixed(1)
        } else if (this.types == "EPC1") {
          var acalepc = acalepc1(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acalepc.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalepc.dgL = lmh.toFixed(8)
          acalepc.dgysAL = aal.toFixed(0)
          this.resultData.push(acalepc);
        } else if (this.types == "EPC2") {

          var acalepc = acalepc2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = TURNS * TURNS * suo * UE * (C + GAP)
                * (D + GAP) / (acalepc.Le + (UE - 1) * GAP);
          } else {
            lmh = TURNS * TURNS * suo
                * (C + GAP) * (D + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          this.resultData.push(acalepc);
        } else if (this.types == "PQ") {
          var acalpq1 = acalpq(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = 0.7853 * TURNS * TURNS * suo * UE * (C + GAP)
                * (C + GAP) / (acalpq1.Le + (UE - 1) * GAP);
          } else {
            lmh = 0.7853 * TURNS * TURNS * suo
                * (C + GAP) * (C + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalpq1.dgL = lmh.toFixed(8)
          acalpq1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalpq1);
        } else if (this.types == "RM1") {
          var acalrmb1 = acalrma(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = 0.7853 * TURNS * TURNS * suo * UE * (C + GAP)
                * (C + GAP) / (acalrmb1.Le + (UE - 1) * GAP);
          } else {
            lmh = 0.7853 * TURNS * TURNS * suo
                * (C + GAP) * (C + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalrmb1.dgL = lmh.toFixed(8)
          acalrmb1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalrmb1);
        } else if (this.types == "RM2") {
          var acalrmb1 = acalrmb(this.form.A, this.form.B, this.form.C, 0, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = 0.7853 * TURNS * TURNS * suo * UE * (C + GAP)
                * (C + GAP) / (acalrmb1.Le + (UE - 1) * GAP);
          } else {
            lmh = 0.7853 * TURNS * TURNS * suo
                * (C + GAP) * (C + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalrmb1.dgL = lmh.toFixed(8)
          acalrmb1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalrmb1);
        } else if (this.types == "EP") {
          var acalep1 = acalep(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = 0.7853 * TURNS * TURNS * suo * UE * (C + GAP)
                * (C + GAP) / (acalep1.Le + (UE - 1) * GAP);
          } else {
            lmh = 0.7853 * TURNS * TURNS * suo
                * (C + GAP) * (C + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalep1.dgL = lmh.toFixed(8)
          acalep1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalep1);
        } else if (this.types == "PM") {
          var acalpm1 = acalpm(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.I);
          var suo = 0.0000012566;
          var fj2 = 0, fj1 = 0, lmh = 0, aal = 0;
          var C = parseFloat(this.form.C);
          var D = parseFloat(this.form.D);
          var GAP = parseFloat(this.form.gap);
          var TURNS = parseFloat(this.form.turns);
          var UE = parseFloat(this.form.ue);
          if (C >= D) {
            fj2 = D;
          } else {
            fj2 = C;
          }
          fj1 = GAP / fj2;
          if (fj1 <= 0.05) {
            lmh = 0.7853 * TURNS * TURNS * suo * UE * (C + GAP)
                * (C + GAP) / (acalep1.Le + (UE - 1) * GAP);
          } else {
            lmh = 0.7853 * TURNS * TURNS * suo
                * (C + GAP) * (C + GAP) / GAP;
          }
          aal = (lmh * 1000000) / (TURNS * TURNS);
          acalpm1.dgL = lmh.toFixed(8)
          acalpm1.dgysAL = aal.toFixed(0)
          this.resultData.push(acalpm1);
        }
      } else if (this.message == "计算磁芯的密度") {
        if (this.types == "EE") {
          var acalee1 = acalee(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcalee1 = bcalee(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = this.form.weight / bcalee1 * 1000;
          acalee1.density = zzl.toFixed(2)
          this.resultData.push(acalee1)
        } else if (this.types == "UF") {
          var acaluf1 = acaluf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcaluf1 = bcaluf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = this.form.weight / bcaluf1 * 1000;
          acaluf1.density = zzl.toFixed(3)
          this.resultData.push(acaluf1);
        } else if (this.types == "环形") {
          var acalo1 = acalo(this.form.A, this.form.B, this.form.C);
          var bcalo1 = bcalo(this.form.A, this.form.B, this.form.C)
          var zzl = this.form.weight / bcalo1 * 1000;
          acalo1.density = zzl.toFixed(3)

          this.resultData.push(acalo1);

        } else if (this.types == "UYF") {
          var acaluyf1 = acaluyf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcaluyf1 = bcaluyf(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = this.form.weight / bcaluyf1 * 1000;
          acaluyf1.density = zzl.toFixed(3)
          this.resultData.push(acaluyf1);
        } else if (this.types == "EC") {
          var acalec1 = acalec(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcalec1 = bcalec(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = this.form.weight / bcalec1 * 1000;
          acalec1.density = zzl.toFixed(3)

          this.resultData.push(acalec1);

        } else if (this.types == "EI、EIF") {

          var acalefd1 = acalei(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalefd1 = bcalei(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H)
          var zzl = this.form.weight / bcalefd1 * 1000;
          acalefd1.density = zzl.toFixed(3)
          this.resultData.push(acalefd1);

        } else if (this.types == "EED") {
          var acaleed1 = acaleed(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var bcaleed1 = bcaleed(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G)
          var zzl = this.form.weight / bcaleed1 * 1000;
          acaleed1.density = zzl.toFixed(3)
          this.resultData.push(acaleed1);
        } else if (this.types == "UI") {
          var acalui1 = acalui(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var bcalui1 = bcalui(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G)
          var zzl = this.form.weight / bcalui1 * 1000;
          acalui1.density = zzl.toFixed(3)
          this.resultData.push(acalui1);
        } else if (this.types == "ET") {
          var acalet1 = acalet(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcalet1 = bcalet(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = this.form.weight / bcalet1 * 1000;
          acalet1.density = zzl.toFixed(3)
          this.resultData.push(acalet1);
        } else if (this.types == "FT") {

          var acalft1 = acalft(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F);
          var bcalft1 = bcalft(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F)
          var zzl = this.form.weight / bcalft1 * 1000;
          acalft1.density = zzl.toFixed(3)
          this.resultData.push(acalft1)
        } else if (this.types == "EFD1") {

          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalefd = bcalefds(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H, this.from.B2);
          var zzl = this.form.weight / bcalefd * 1000;
          acalefd1.density = zzl.toFixed(3)
          acalefd1.QQW = po2.toFixed(1)
          this.resultData.push(acalefd1);
        } else if (this.types == "EFD2") {
          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalefd = bcalefd2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H, this.from.B2, this.form.D2);
          var zzl = this.form.weight / bcalefd * 1000;
          acalefd1.density = zzl.toFixed(3)
          acalefd1.QQW = po2.toFixed(1)
          this.resultData.push(acalefd1);
        } else if (this.types == "EFD3") {
          var acalefd1 = acalefd(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalefd = bcalefd3(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H, this.from.B2, this.form.D2);
          var zzl = this.form.weight / bcalefd * 1000;
          acalefd1.density = zzl.toFixed(3)
          acalefd1.QQW = po2.toFixed(1)
        } else if (this.types == "EPC1") {
          var acalepc = acalepc1(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalepc = bcalepc1(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H)
          var zzl = this.form.weight / bcalepc * 1000;
          acalepc.density = zzl.toFixed(3)
          this.resultData.push(acalepc);
        } else if (this.types == "EPC2") {

          var acalepc = acalepc2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H);
          var bcalepc = bcalepc2(this.form.A, this.form.B, this.form.B1, this.form.C, this.form.D, this.form.D1, this.form.E, this.form.F, this.form.H)
          var zzl = this.form.weight / bcalepc * 1000;
          acalepc.density = zzl.toFixed(3)
          this.resultData.push(acalepc);
        } else if (this.types == "PQ") {
          var acalpq1 = acalpq(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H);
          var po2 = bcalpq(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H)
          var zzl = this.form.weight / po2 * 1000;
          acalpq1.density = zzl.toFixed(3)
          this.resultData.push(acalpq1);
        } else if (this.types == "RM1") {
          var acalrmb1 = acalrma(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var po2 = bcalrma(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I)
          var zzl = this.form.weight / po2 * 1000;
          acalrmb1.density = zzl.toFixed(3)
          this.resultData.push(acalrmb1);
        } else if (this.types == "RM2") {
          var acalrmb1 = acalrmb(this.form.A, this.form.B, this.form.C, 0, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I);
          var po2 = bcalrmb(this.form.A, this.form.B, this.form.C, 0, this.form.E, this.form.F, this.form.G, this.form.H, this.form.H1, this.form.I)
          var zzl = this.form.weight / po2 * 1000;
          acalrmb1.density = zzl.toFixed(3)
          this.resultData.push(acalrmb1);
        } else if (this.types == "EP") {
          var acalep1 = acalep(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G);
          var po2 = bcalep(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G)
          var zzl = this.form.weight / po2 * 1000;
          acalep1.density = zzl.toFixed(3)
          this.resultData.push(acalep1);
        } else if (this.types == "PM") {
          var acalpm1 = acalpm(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.I);
          var po2 = bcalpm(this.form.A, this.form.B, this.form.C, this.form.D, this.form.E, this.form.F, this.form.G, this.form.H, this.form.I)
          var zzl = this.form.weight / po2 * 1000;
          acalpm1.density = zzl.toFixed(3)
          this.resultData.push(acalpm1);
        }
      }
    }
  })
    }
  },

  created() {
    if (this._isMobile()) {
      if(this._isMobile().indexOf("iPad")!=-1){
        this.isPC=true;
        this.isPhone=false;
      }else {
        this.isPC=false;
        this.isPhone=true;

      }

    } else {
      // alert("pc端");
      // router.replace('/test');
      this.isPC=true;
      this.isPhone=false;

    }
  },

}
</script>

<style scoped>
.dengxiao{
  overflow-x:hidden;
}
.dengxiao .el-col .grid-content {
  border: 2px solid #ffffff; /* 你可以根据需要调整边框的颜色和宽度 */
}
.dengxiao .el-col:hover .grid-content {
  border: 2px solid #409EFF; /* 你可以根据需要调整边框的颜色和宽度 */
  cursor: pointer;
}
</style>



